import React, { Component } from "react";
import Credentials from "./credentials";
import RegisterProvider from "./registerProvider";
import { getInitialState } from "./util";
//assets
import Chrome from "../../../../static/images/chrome.png";
import Explorer from "../../../../static/images/explorer.svg";
import Mozilla from "../../../../static/images/mozilla.png";
import AppName from "../../../../static/images/appName.png";
import * as sessionActions from "../../../Redux/actions/sessionActions";
import { ReactTitle } from "react-meta-tags";
import { withTranslation } from "react-i18next";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

class RegisterNewProviderContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successfulLogin: false,
      data: {},
    };
  }

  componentDidMount() {
    this.props.actions.setPage("");
  }

  nextStep = (data) => {
    this.setState({ successfulLogin: true, data: getInitialState(data) });
  };

  render() {
    const { t } = this.props;
    const { successfulLogin, data } = this.state;

    return (
      <>
        <div
          className={`register-provider full-height ${
            !successfulLogin ? "wrapper-background-image" : ""
          }`}
        >
          <div className="wrapper-login">
            <ReactTitle title={`${t("login.meta.title")} - ${t("appName")}`} />
            <header className="main-login-header">
              <div className="login-header-container">
                <div className="container-item">
                  <img src={AppName} alt="Nombre" />
                </div>
                <div className="browser">
                  <p className="title">{t("login.bottom.advertisingText")}</p>
                  {browsers.map(({ text, img }) => (
                    <p className="browser-supported" key={text}>
                      <img
                        src={img}
                        alt="Navegadores soportados"
                      />
                      {text}
                    </p>
                  ))}
                </div>
              </div>
            </header>
            {!successfulLogin ? (
              <Credentials nextStep={this.nextStep} />
            ) : (
              <RegisterProvider initialState={data} />
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
};

export default withTranslation()(
  connect(null, mapDispatch)(RegisterNewProviderContainer)
);

const browsers = [
  { text: "IE 11+", img: Explorer },
  { text: "Mozilla Firefox", img: Mozilla },
  { text: "Google Chrome", img: Chrome },
];
